// Desktop Search Toggle Functionality
export function initDesktopSearch() {
  const searchToggle = document.querySelector('.search-toggle');
  const searchContainer = document.querySelector('.search-form-container');
  const searchField = document.querySelector('.search-form-container .search-field');

  if (!searchToggle || !searchContainer || !searchField) return;

  let isSearchOpen = false;

  // Toggle search form visibility
  searchToggle.addEventListener('click', function(e) {
    e.preventDefault();
    
    isSearchOpen = !isSearchOpen;
    
    if (isSearchOpen) {
      // Open search form
      searchContainer.classList.add('active');
      
      // Focus the search field after animation completes
      setTimeout(() => {
        searchField.focus();
      }, 150); // Slightly before animation completes for smoother UX
    } else {
      // Close search form
      searchContainer.classList.remove('active');
      searchField.blur();
    }
  });

  // Close search form when clicking outside
  document.addEventListener('click', function(e) {
    if (isSearchOpen && 
        !searchToggle.contains(e.target) && 
        !searchContainer.contains(e.target)) {
      searchContainer.classList.remove('active');
      searchField.blur();
      isSearchOpen = false;
    }
  });

  // Close search form when pressing Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isSearchOpen) {
      searchContainer.classList.remove('active');
      searchField.blur();
      isSearchOpen = false;
    }
  });

  // Prevent form submission from closing the search (optional)
  const searchForm = document.querySelector('.search-form-container .search-form');
  if (searchForm) {
    searchForm.addEventListener('submit', function(e) {
      // Keep search form open after submission
      e.preventDefault();
      
      // Get search query
      const query = searchField.value.trim();
      if (query) {
        // Redirect to search results
        window.location.href = `${window.location.origin}/?s=${encodeURIComponent(query)}`;
      }
    });
  }
}
